document.addEventListener('swipe-card:swiped', (event) => {

  const value = {
    left: 'screening',
    right: 'approval',
    down: 'skip'
  }[event.detail.direction];


  document.querySelector(`button[value="${value}"]`).click();
});
